import "./TheNexus.module.css";
import NexusHeader from "@/reusable_sections/Header";
import PixelForceCommand from "./sections/PixelForceCommand";
import EliteOperatives from "./sections/EliteOperatives";
import BattleHistory from "./sections/BattleHistory";
import CommunityPerks from "./sections/CommunityPerks";
import DigitalSpoils from "./sections/DigitalSpoils";
import TheHolodeckPreview from "./sections/TheHolodeckPreview";
import NexusFooter from "@/reusable_sections/Footer";
export default function TheNexusPage() {
  return <div>
      <NexusHeader />
      <PixelForceCommand />
      <EliteOperatives />
      <BattleHistory />
      <CommunityPerks />
      <DigitalSpoils />
      <TheHolodeckPreview />
      <NexusFooter />
    </div>;
}